import { getLifecycle } from 'service/utils';

const REDUCER_NAME: string = 'TOURNAMENT_SUBSCRIPTION';

export const GET_SUBSCRIPTIONS = getLifecycle(REDUCER_NAME, 'GET_SUBSCRIPTIONS');
export const SUBSCRIBE = getLifecycle(REDUCER_NAME, 'SUBSCRIBE');
export const GET_USER_SUBSCRIPTION = getLifecycle(REDUCER_NAME, 'GET_USER_SUBSCRIPTION');
